import React, { useEffect, useState } from 'react';
import Input from '../../../../shared/components/Input/Input';
import usePlanningDialog from '../hooks/usePlanningDialog';

export default function PlanningSyncSettings({
  account,
  hasCredentials,
  connectionStatus,
  onClose,
  onSave,
  onTest,
  onImport,
  saving,
  importing,
  testingConnection,
}) {
  const [draft, setDraft] = useState(account);
  const dialogRef = usePlanningDialog(onClose);

  useEffect(() => setDraft(account), [account]);

  const change = (event) => {
    setDraft((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  return (
    <div className="planning-modal-backdrop" onMouseDown={(mouseEvent) => mouseEvent.target === mouseEvent.currentTarget && onClose()}>
      <section ref={dialogRef} className="planning-sync-settings" role="dialog" aria-modal="true" aria-label="Paramètres CalDAV" tabIndex="-1">
        <header>
          <div>
            <strong>Synchronisation CalDAV</strong>
            <p>Le planning ERP reste la source métier principale.</p>
          </div>
          <button aria-label="Fermer" onClick={onClose}>×</button>
        </header>
        <Input fullWidth label="URL du calendrier" name="caldavUrl" value={draft.caldavUrl} onChange={change}/>
        <Input fullWidth label="Utilisateur" name="caldavUsername" value={draft.caldavUsername} onChange={change}/>
        <Input fullWidth type="password" label={hasCredentials ? 'Nouveau mot de passe (facultatif)' : 'Mot de passe'} name="caldavPassword" value={draft.caldavPassword || ''} onChange={change}/>
        <div className={`planning-sync-state planning-sync-state--${connectionStatus}`} role="status">
          {connectionStatus === 'connected' ? 'Connexion testée avec succès.' : connectionStatus === 'error' ? 'La dernière tentative de connexion a échoué.' : hasCredentials ? 'Identifiants enregistrés — connexion non testée.' : 'CalDAV non configuré.'}
          {account.lastSyncAt && <small>Dernière synchronisation : {new Date(account.lastSyncAt).toLocaleString('fr-FR')}</small>}
          {account.connectionError && <small>{account.connectionError}</small>}
        </div>
        <footer>
          <button className="basic-button" disabled={saving || testingConnection} onClick={() => onTest(draft)}>
            {testingConnection ? 'Test en cours…' : 'Tester'}
          </button>
          <button className="basic-button" disabled={saving || importing || !hasCredentials} onClick={onImport}>
            {importing ? 'Import en cours…' : 'Importer'}
          </button>
          <button className="basic-button active" disabled={saving || importing || testingConnection} onClick={() => onSave(draft)}>
            {saving ? 'Enregistrement…' : 'Enregistrer'}
          </button>
        </footer>
      </section>
    </div>
  );
}
